// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--BWque","icon":"dd31006766--icon--axpW1","desktop":"dd31006766--desktop--Sgjz9","mobile":"dd31006766--mobile--Ws_Rq"};